import { render, staticRenderFns } from "./Tickets.vue?vue&type=template&id=081bb59e&"
import script from "./Tickets.vue?vue&type=script&lang=ts&"
export * from "./Tickets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports